import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { moreResults } from '../data/testimonials';
export function MoreResults() {
  return <section className="bg-white py-16 sm:py-20" aria-labelledby="results-title" data-id="element-181" data-mp="28f80yjn3pvsp">
      <div className="mx-auto max-w-5xl px-4" data-id="element-182" data-mp="28ddhl9rhabqq">
        <p className="text-center text-xs font-extrabold uppercase tracking-[.18em] text-teal" data-id="element-183" data-mp="2d6zvt6dainon">Más resultados reales</p>
        <h2 id="results-title" className="mt-3 text-center text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-184" data-mp="2h709goskeuun">
          Profesionales de museos y docentes que ya cambiaron su forma de trabajar
        </h2>
        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-185" data-mp="2r68zj6kb7pbq">
          {moreResults.map(([initials, name, place, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-2xl border border-line bg-mist p-6" data-id="element-186" data-mp="wrojj76xohyo" data-mpi={index}>
              <QuoteIcon className="h-6 w-6 text-teal" data-id="element-187" data-mp="3ilej3m1l5hcm" />
              <blockquote className="mt-4 flex-1 text-sm italic leading-relaxed text-muted" data-id="element-188" data-mp="3dmv1tyxxstql">“{quote}”</blockquote>
              <div className="mt-5 flex items-center gap-3 border-t border-line pt-4" data-id="element-189" data-mp="38purvcxyv6u7">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-deep text-sm font-extrabold text-white" data-id="element-190" data-mp="a5uwv6zc0z72">
                  {initials}
                </span>
                <span data-id="element-191" data-mp="7ynajm1mcb2">
                  <b className="block text-sm text-ink" data-id="element-192" data-mp="75d18nvl4o6">{name}</b>
                  <small className="text-xs text-muted" data-id="element-193" data-mp="3sd2axo2210em">{place}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}